import React, { Component } from 'react';

export default class Footer extends Component {
	render() {
		return (
			<div className="section-body">
				<footer className="footer">
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-12 col-sm-12 text-md-right">
								Copyright © 2020 <a rel="noopener noreferrer" href="https://codepso.com" target="_blank">Codepso</a>.
              </div>
						</div>
					</div>
				</footer>
			</div>
		);
	}
}
